import script from "./KeyDocumentCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeyDocumentCard.vue?vue&type=script&lang=ts&setup=true"

import "./KeyDocumentCard.vue?vue&type=style&index=0&id=4c07b348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c07b348"]])

export default __exports__